export default "__VITE_ASSET__D5QGNVYK__"